import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
    selector: 'app-button-tag',
    templateUrl: './button-tag.component.html',
    styleUrls: ['./button-tag.component.css']
})
export class ButtonTagComponent implements OnInit {

    @Input() receivedBtnLabelMessage: string;
    @Input() btnClassName: string;
    @Input() formIsValid: string;
    @Input() imgPath: string;
    @Input() imageNameReceived: string;
    @Output() action = new EventEmitter<any>();


    constructor() {
    }

    ngOnInit() {

    }



}
